<template>
  <div class="home">
    <p>a</p>
    <HelloWorld msg="Welcome to Your Vue.js App" />
    aaa
    <HelloWorld msg="Welcome to Your Vue.js App" />
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "Home",

  components: {
    HelloWorld,
  },

  data: () => ({}),

  methods: {},

  mounted() {
    this.$store.commit("setPageTitle", "Inicio");
  },
};
</script>
